// Lokalių kelionių duomenų valymas (Nustatymai → „Išvalyti mano duomenis").
// Ištrina aplankytas vietas, prisiminimus, nuotraukas, išsaugotas, neseniai, km.
// NEtrina: onboarding būsenos, navigacijos, kalbos preferencijų.

const LOCAL_RAKTAI = [
  'aplankytos_vietos',
  'prisiminimai',
  'issaugotos_vietos',
  'neseniai_vietos',
  'numatyti_km',
  'issukiai_matyti',
]

export function isvalytiKelioniuDuomenis() {
  try {
    LOCAL_RAKTAI.forEach(r => localStorage.removeItem(r))
  } catch {}
  // IndexedDB nuotraukos
  try {
    if ('indexedDB' in window) indexedDB.deleteDatabase('kelioniu')
  } catch {}
}
